import React from 'react';
import { Controller, Control } from 'react-hook-form';
import InputMask from 'react-input-mask';
import Grid from '@material-ui/core/Grid';
import TextField from 'common/components/TextField';
import { DEFAULT_GRID_CONTAINER_SPACING } from 'common/constants';
import ErrorPanel from 'common/components/ErrorPanel';
import {
    BILLING_ADDRESS,
    CITY,
    COMPANY,
    POST_CODE,
    STREET,
    STREET_NUMBER,
    TAX_ID_NUMBER,
    COUNSEL_PARENTS,
} from '../../../common/constants';
import { CheckoutValues } from 'store/ducks/checkout/types';

type Props = {
    checkoutValues: CheckoutValues;
    control: Control;
    differentData: boolean;
    errors: any;
};

const InvoiceData: React.FC<Props> = ({ checkoutValues, control, errors }) => {
    const getName = (name: string) => `${BILLING_ADDRESS}.${name}`;

    const { city, company, postcode, street, streetNumber, taxIdNumber } =
        checkoutValues.billingAddress || {};

    const orderType = checkoutValues.orderType;

    return (
        <Grid container spacing={DEFAULT_GRID_CONTAINER_SPACING}>
            <Grid item xs={12} md={5}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={company || ''}
                    label={orderType === COUNSEL_PARENTS ? '* Nabywca (rada rodziców)' : '* Nabywca (urząd, miasto, gmina)'}
                    name={getName(COMPANY)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(COMPANY)} />
            </Grid>
            <Grid item xs={12} md={5}>
                <Controller
                    as={
                        <InputMask alwaysShowMask={false} mask="9999999999">
                            {(inputProps: any) => <TextField fullWidth {...inputProps} />}
                        </InputMask>
                    }
                    control={control}
                    defaultValue={taxIdNumber || ''}
                    label={orderType === COUNSEL_PARENTS ? 'NIP' : '* NIP'}
                    name={getName(TAX_ID_NUMBER)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(TAX_ID_NUMBER)} />
            </Grid>
            <Grid item xs={12} md={4}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={street || ''}
                    label="* Ulica"
                    name={getName(STREET)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(STREET)} />
            </Grid>
            <Grid item xs={12} md={3}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={streetNumber || ''}
                    label="* Nr domu / lokalu"
                    name={getName(STREET_NUMBER)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(STREET_NUMBER)} />
            </Grid>
            <Grid item xs={12} md={3}>
                <Controller
                    as={
                        <InputMask alwaysShowMask={false} mask="99-999">
                            {(inputProps: any) => <TextField {...inputProps} fullWidth />}
                        </InputMask>
                    }
                    control={control}
                    defaultValue={postcode || ''}
                    label="* Kod pocztowy"
                    name={getName(POST_CODE)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(POST_CODE)} />
            </Grid>
            <Grid item xs={12} md={4}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={city || ''}
                    label="* Miejscowość"
                    name={getName(CITY)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(CITY)} />
            </Grid>
        </Grid>
    );
};

export default InvoiceData;
